export const PROFILE_CARD_EDIT_BUTTON_TRANSITIONS_SPRING_PROPS = Object.freeze({
    from: {
        opacity: 0,
        transform: 'scale3d(0.75, 0.75, 0.75)'
    },
    enter: {
        opacity: 1,
        transform: 'scale3d(1, 1, 1)'
    },
    leave: {
        opacity: 0,
        transform: 'scale3d(0.75, 0.75, 0.75)'
    }
});
